export default {
  login: "FrontEnd/login",
  getNewAccessToken: "FrontEnd/getNewAccessToken",
  changePassword: "BackEnd/changePassword",
  changePasswordByAdmin: "BackEnd/changePasswordByAdmin",
  getImg: "authfiles/getfiles/",
};
